import React from 'react';

const STATUS_CONFIG = {
  validada: {
    label: 'Validada',
    className: 'bg-green-100 text-green-800 border-green-200',
  },
  pendiente: {
    label: 'Pendiente',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  error_ocr: {
    label: 'Error OCR',
    className: 'bg-red-100 text-red-800 border-red-200',
  },
  procesando: {
    label: 'Procesando',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  borrador: {
    label: 'Borrador',
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  },
  duplicada: {
    label: 'Duplicada',
    className: 'bg-orange-100 text-orange-800 border-orange-200',
  },
};

export default function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Desconocido',
    className: 'bg-gray-100 text-gray-600 border-gray-200',
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}
    >
      {config.label}
    </span>
  );
}
